module.exports = __webpack_public_path__ + "static/media/product-3.0984558a.png";